export function setTableData(state, payload) {
    state.items.data = payload.data;
    state.items.pagination = payload.pagination;
    state.items.filter = payload.filter;

}
export function setStatus(state, payload) {
    console.log('payload', payload)
    state.status.active_tracks = payload.active_tracks;
    state.status.completed_tracks = payload.completed_tracks;
    state.status.upcoming_tracks = payload.upcoming_tracks;

}
